export default {
  reportsQuery: {
    From: new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0),
    To: new Date(),
    Type: 'PARKING',
    ReportType: 'PAYOUT',
    GroupBy: 'PLACE'
  },
  reportTypes: [],
  selectedReportType: {
    ID: 1,
    CreatedAt: '0001-01-01T00:00:00Z',
    UpdatedAt: '0001-01-01T00:00:00Z',
    DeletedAt: null,
    Code: 'PAYOUT',
    Name: 'Payout',
    VisibleForAll: true,
    VisibleForZone: '',
    WebViewEnabled: true,
    XlsxEnabled: true,
    MonthlyReportOnly: false
  },
  operators: []
}
